import { render, staticRenderFns } from "./PageRecharge.vue?vue&type=template&id=3227ee95&"
import script from "./PageRecharge.vue?vue&type=script&lang=js&"
export * from "./PageRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports